import { render, staticRenderFns } from "./CLOSE.vue?vue&type=template&id=33356e48"
import script from "./CLOSE.vue?vue&type=script&lang=js"
export * from "./CLOSE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports